import React, { Component } from 'react';
import SideMenuAir from '../../components/SideMenuAir/SideMenuAir';
import AirBg from '../../components/AirBg/AirBg';
import styled from 'styled-components';
import CardCO2 from '../../components/CardCO2/CardCO2';
import InfoComposition from '../../components/InfoComposition/InfoComposition';
import InfoNaturalthreats from '../../components/InfoNaturalthreats/InfoNaturalthreats';
import InfoAcidification from '../../components/InfoAcidification/InfoAcidification';
import InfoDeforestation from '../../components/InfoDeforestation/InfoDeforestation';
import {Link} from 'react-router-dom';
import back from '../../assets/back.png';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;
const Navlink = styled(Link)`

    text-decoration:none;
    color:#ffffff;
  
`;

const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
  margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;
const Backico = styled.img`
  margin-left:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:20px;
  height:auto;
  margin-right:5px;
`;

class Atmosphere_CO2 extends Component{


  render(){

    return(
      
        <body> 

          <SideMenuAir />
          <AirBg/>
          
          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree><Link to="/Atmosphere"><Backico src= {back}/></Link><Navlink to="/Atmosphere">Atmosphere</Navlink><Navlink to="/Atmosphere_Composition">/ Composition</Navlink>/ CO2</Tree>           
          </Contentwrapper>        
              <CardCO2/>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
              <Impactwrapper><Link to="/Oceans_Acidification"><InfoAcidification/></Link></Impactwrapper>  
              <Impactwrapper><Link to="/Land_Deforestation"><InfoDeforestation/></Link></Impactwrapper>
              
           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>

        </body>
      
      );

  } 
}

export default Atmosphere_CO2;